import { action, computed, observable } from 'mobx';
import Organization from '../entity/Organization';

class OrganizationStore {
  public static generateFromApiResponse(res: any): Organization {
    const id = res.id;
    const username = res.username;
    const profileImageUrl = res.avatar_image_url;
    return new Organization({ id, username, profileImageUrl });
  }

  @observable public organizations: Organization[] = [];
  @observable public selectedOrganizationId: string;
  @observable public isLoading: boolean = true;

  @computed
  get selectedOrganization(): Organization | null {
    return this.organizations.find(item => item.id === this.selectedOrganizationId) || null;
  }

  @action
  public addOrganizationListItem(res: any): void {
    if (!this.organizations.find(org => org.id === res.id)) {
      this.organizations.push(OrganizationStore.generateFromApiResponse(res));
    }
  }

  @action
  public addOrganizationList(res: any[]): void {
    res.map((organization): any => {
      if (!this.organizations.find(org => org.id === organization.id)) {
        this.organizations.push(OrganizationStore.generateFromApiResponse(organization));
      }
    });
  }

  @action
  public setLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }

  @action
  public setSelectedOrganizationId(id: string): void {
    this.selectedOrganizationId = id;
  }
}

export default OrganizationStore;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/store/OrganizationStore.ts